import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const SuccessPage = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 },
    },
  };

  return (
    <main className="min-h-screen pt-24 bg-gradient-to-br from-background via-primary/5 to-accent/5 flex items-center justify-center px-4">
      <motion.div
        className="max-w-2xl w-full text-center"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {/* Celebratory Animation */}
        <motion.div className="mb-8" variants={itemVariants}>
          <div className="text-6xl mb-4">🎉</div>
          <motion.h1
            className="text-5xl sm:text-6xl font-light italic text-primary mb-4"
            variants={itemVariants}
          >
            Thank You!
          </motion.h1>
          <motion.p
            className="text-xl text-foreground/70"
            variants={itemVariants}
          >
            Thanks for submitting your info! Please DM us on Instagram and We'll
            contact you shortly with your payment link and next steps. Get ready
            for a real connection
          </motion.p>
        </motion.div>

        {/* Next Steps */}
        <motion.div
          className="bg-card rounded-lg shadow-lg p-8 border border-border mb-8"
          variants={itemVariants}
        >
          <h2 className="text-2xl font-semibold text-foreground mb-6">
            What Happens Next
          </h2>
          <div className="space-y-4 text-left">
            {[
              {
                step: 1,
                title: "Review",
                description: "Our team will review your profile soon",
              },
              {
                step: 2,
                title: "Matching",
                description:
                  "We'll carefully match you with a compatible partner",
              },
              {
                step: 3,
                title: "Contact",
                description: "We'll reach out with date details and next steps",
              },
            ].map((item) => (
              <motion.div
                key={item.step}
                className="flex gap-4"
                variants={itemVariants}
              >
                <div className="w-10 h-10 bg-primary text-primary-foreground rounded-full flex items-center justify-center font-bold flex-shrink-0">
                  {item.step}
                </div>
                <div className="text-left">
                  <h3 className="font-semibold text-foreground">
                    {item.title}
                  </h3>
                  <p className="text-foreground/60 text-sm">
                    {item.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* CTA Buttons */}
        <motion.div
          className="flex flex-col sm:flex-row gap-4 justify-center"
          variants={itemVariants}
        >
          <Link to="/">
            <button className="px-8 py-3 border-2 border-primary text-primary rounded-lg font-semibold hover:bg-primary/5 transition w-full sm:w-auto">
              Back to Home
            </button>
          </Link>
        </motion.div>
      </motion.div>
    </main>
  );
};

export { SuccessPage };
